module.exports = __webpack_public_path__ + "media/images/John-pear copy-d28697011192100f3c0b1c61f37a0086.png";